import { useEffect } from "react";

/**
 * Inject a JSON-LD <script> tag into <head> for the lifetime of the component.
 * - id: unique key so multiple JSON-LD blocks can coexist and update independently.
 * - data: any serializable object (Schema.org graph).
 *
 * The tag is removed on unmount, keeping the DOM clean between routes.
 * Zero visual side-effects.
 */
export default function useJsonLd(id, data) {
  useEffect(() => {
    if (!id || !data) return undefined;
    const tagId = `ldjson-${id}`;
    let tag = document.getElementById(tagId);
    if (!tag) {
      tag = document.createElement("script");
      tag.type = "application/ld+json";
      tag.id = tagId;
      document.head.appendChild(tag);
    }
    try {
      tag.text = JSON.stringify(data);
    } catch {
      /* ignore serialization errors */
    }
    return () => {
      const el = document.getElementById(tagId);
      if (el && el.parentNode) el.parentNode.removeChild(el);
    };
  }, [id, data]);
}
